import { Heading, Icons, EmptyState, Paragraph } from "@ir/ui";

interface Props {
  title: string;
  description: string;
  icon: Icons;
}

const EmptyKpiCard = ({ title, description, icon }: Props) => {
  return (
    <EmptyState
      icon={icon}
      title={
        <Heading level={6} className="text-grey-700 font-bold mt-3">
          {title}
        </Heading>
      }
      description={<Paragraph className="text-grey-500 font-regular mb-0">{description}</Paragraph>}
    />
  );
};

export default EmptyKpiCard;
